import { getImageQuality } from '../utils'

const configAggregator = (node) => {
    return {
        image: node.getAttribute('data-w-image'),
        imageQuality: getImageQuality([])
    }
}

export default configAggregator
